import React, {useState, useRef, useEffect} from 'react'
import { motion } from 'framer-motion'

import './slide.css'

function Slide({imgs}) {

    const [width, setWidth] = useState(0)
    const carousel = useRef()

    useEffect(() => {
        setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth)
    }, [])

    return (
        <div className='container-fluid slider-container'>
            <motion.div ref={carousel} className='carousel' whileTap={{cursor: "grabbing"}}>
                <motion.div drag="x" dragConstraints={{right: 0, left: -width}} className='carousel-inner'>
                    {imgs.map(img => (
                        <motion.div key={img.image} className={`carousel-item ${img.title ? "img-with-desc" : "img-with-no-desc"}`}>
                            <img src={img.image} alt='' />
                            {img.title && <ImgDetail title={img.title} />}
                        </motion.div>
                    ))}
                </motion.div>
            </motion.div>
        </div>
    )
}


const ImgDetail = ({title}) => (
    <div className='description'>
        <p className='serif'>{title}</p>
    </div>
) 

export default Slide